import { useRef } from "react";

export function useInputRefs() {
  const inputRefs = useRef<Map<string, HTMLInputElement>>(new Map());

  const setInputRef = (refKey: string, element: HTMLInputElement | null) => {
    if (element) {
      inputRefs.current.set(refKey, element);
    } else {
      inputRefs.current.delete(refKey);
    }
  };

  const focusInput = (index: number, field: "key" | "value") => {
    const inputRef = inputRefs.current.get(`${index}-${field}`);
    if (inputRef) {
      inputRef.focus();
    }
  };

  return {
    setInputRef,
    focusInput,
  };
}
